import type { PartnerType } from './generated/client';

// These codes belong to Travel's legacy ledger, not Trading's type registry.
export const TRAVEL_CARI_BUILTINS = [
  ['M', 'Müşteriler', 'Customers', null],
  ['W', 'Diğer Müşteriler', 'Other Customers', null],
  ['AH', 'Açık Hesaplar', 'Open Accounts', 'VENDOR'],
  ['E', 'Devlet Daireleri', 'Government Offices', null],
  ['O', 'Oteller', 'Hotels', 'HOTEL'],
  ['S', 'Tur Operatörleri', 'Tour Operators', 'TOUR_OPERATOR'],
  ['T', 'Taşıma', 'Transport', 'TRANSFER'],
  ['H', 'Havayolları', 'Airlines', 'AIRLINE'],
  ['D', 'Deniz ve Tren Bileti', 'Sea and Rail Tickets', 'ACTIVITY'],
  ['I', 'Sigorta', 'Insurance', 'INSURANCE'],
  ['G', 'Piyasa Alış Fatura', 'Suppliers', 'SUPPLIER'],
  ['RC', 'Rent a Car', 'Car Rental', 'CAR_RENTAL'],
  ['R', 'Rehberler', 'Guides', 'GUIDE'],
  ['V', 'Vize', 'Visa Agencies', 'SUPPLIER'],
  ['C', 'Cruise', 'Cruises', 'CRUISE'],
  ['Q', 'Restoranlar', 'Restaurants', 'RESTAURANT'],
  ['CS', 'Çiftlik Satıcıları', 'Farm Vendors', 'SUPPLIER'],
  ['P', 'Personel', 'Personnel', 'VENDOR'],
  ['ORT', 'Ortaklar', 'Partners', 'VENDOR'],
  ['L', 'Gelir/Gider', 'Income / Expense', 'ACTIVITY'],
  ['A101', 'Alınan Çekler', 'Cheques Received', 'VENDOR'],
  ['V103', 'Verilen Çekler', 'Cheques Issued', 'VENDOR'],
  ['X', 'Avukata Verilenler', 'Legal Accounts', 'VENDOR'],
  ['X103', 'Verilen Teminat Çeki', 'Guarantee Cheques Issued', 'VENDOR'],
].map(([code, name, nameEn, partnerType], index) => ({
  code: code!,
  name: name!,
  nameEn: nameEn!,
  source: partnerType === null ? ('customer' as const) : ('partner' as const),
  partnerType: partnerType as PartnerType | null,
  sortOrder: (index + 1) * 10,
}));

export const TRAVEL_PARTNER_CARI_CODES: Record<string, string> = {
  HOTEL: 'O',
  AIRLINE: 'H',
  TOUR_OPERATOR: 'S',
  TRANSFER: 'T',
  CRUISE: 'C',
  CAR_RENTAL: 'RC',
  GUIDE: 'R',
  INSURANCE: 'I',
  RESTAURANT: 'Q',
  ACTIVITY: 'D',
  SUPPLIER: 'G',
  VENDOR: 'X',
};

export function travelCustomerCariCode(customerType?: string): string {
  return customerType === 'GOVERNMENT' ? 'E' : customerType === 'CORPORATE' ? 'W' : 'M';
}
